import { TQuestionLabel } from '../interfaces';

const getQuestionTextValue = (value: TQuestionLabel, instance: string): string => {
  switch (typeof value) {
    case 'object':
      return value[instance];
    case 'string':
      return value;
    default:
      return '';
  }
};

export default getQuestionTextValue;
